import { gql } from 'urql';

export const mutationRemoveDirectoryItem = gql`
  mutation RemoveDirectoryItem($directoryId: String!, $itemId: String!) {
    removeDirectoryItem(directoryId: $directoryId, directoryItemId: $itemId)
  }
`;
